import { extend } from 'sk-ui/lib/utils/util.js'

import caseBusiDetail from './metaData/caseBusiDetail'
import caseBusiForm from './metaData/caseBusiForm'

import updateOldToNewProduct from '@/components/UpdateOldToNewProduct'

export default {
  caseBusiCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: caseBusiForm,
      props
    })
  },
  caseBusiEdit({ commit }, params) {
    const props = {
      title: '编辑用例',
      params: {
        id: params.rowIds[0]
      },
      'view.content[$id=testCaseCode].$el': { disabled: true }
    }
    const editForm = extend(true, {}, caseBusiForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  caseBusiDetail({ commit }, row) {
    const props = {
      params: {
        id: row.id
      }
    }
    this.dispatch('OpenDetailDialog', {
      metaData: caseBusiDetail,
      props
    })
  },
  batchUpdateBusiProduct({ commit }, params) {
    var dialog = params.viewController.$dialog({
      template: h => {
        const caseType = 'BUSINESS'
        return (
          <sky-update-old-to-new-product
            caseType={caseType}
            onCb={function() {
              dialog.remove()
              params.viewController.handleRefresh()
            }}
          />
        )
      },
      components: {
        updateOldToNewProduct
      },
      props: {
        title: '批量升级产品版本',
        width: '22%',
        showDefaultFooter: false, //隐藏确定和取消按钮
        closeOnPressEscape: false
      }
    })
  }
}
